import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import IcomoonReact from "icomoon-react";
import React from "react";
import { compose, margin, MarginProps } from "styled-system";

import { ColorPalette, fontSizes } from "~/components/styles/theme";

import iconSet from "./selection.json";

type Color = keyof typeof ColorPalette;
type Font = keyof typeof fontSizes;

export type IconName =
  | "alert"
  | "arrow-right"
  | "arrow-left"
  | "camera"
  | "location"
  | "map"
  | "trash"
  | "photo";

type Props = MarginProps & {
  color?: Color;
  size?: Font;
  icon: IconName;
  className?: string;
  width?: string;
};

const Icons = styled(IcomoonReact)<MarginProps>(
  () =>
    css({
      flexShrink: 0,
    }),
  () => compose(margin),
);

export const Icon = (props: Props) => {
  const { color, size, icon, className = "", ...styles } = props;
  return (
    <Icons
      {...styles}
      className={className}
      iconSet={iconSet}
      color={color && ColorPalette[color]}
      size={size && fontSizes[size]}
      icon={`icon-${icon}`}
    />
  );
};
